export const SessionIntegritySeverity = Object.freeze({
  ERROR: 'error',
  WARNING: 'warning',
});

export type SessionIntegritySeverityValues = typeof SessionIntegritySeverity[keyof typeof SessionIntegritySeverity];

export interface ISessionIntegrityIssue {
  code: string;
  severity: SessionIntegritySeverityValues;
  message?: string;
  field?: string;
  details?: string;
}

export interface ISessionIntegritySummary {
  updatedAt: string;
  errorsCount: number;
  warningsCount: number;
  issues: ISessionIntegrityIssue[];
}
